declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { FDService } from '../../../services/fd.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FDActorDocRequest, FdActorReportsDocController } from '../../../models/formdesign/fd.model';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { DBOperation } from '../../../enums/enum';
import { NgbActorFormsModal } from './modals/actorforms.modal';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../animations/router.animations';
@Component({
  selector: 'actorforms',
  templateUrl: './actorforms.component.html',
  styleUrls: ['./actorforms.component.scss']
  
})

export class ActorReportsComponent implements OnInit {

  CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorReportTemplateCode: number = 0;

  CurrentFdActorReportsDocController: FdActorReportsDocController[];

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private fdservice: FDService,
    private modalService: NgbModal) { }


  ngOnInit() {

    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFDActorDocRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;

    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();

    this.GetFdActorReportsDocController();



  }

  GetFdActorReportsDocController() {
    this.StartRefreshing();
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorReportsDocController = this.ApiResData.Result;

          this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  //
  //

  public onSubmitTemplate() {
    if (this.ActorReportTemplateCode > 0) {
      this.StartRefreshing();
      this.CurrentFDActorDocRequest.ConditionalOperator = 1;
      this.CurrentFDActorDocRequest.ActorReportTemplateCode = this.ActorReportTemplateCode;

      this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

              alertFunctions.AlertParam('Saved Successfully.....!');


              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              //this.activeModal.close();
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  //
  isREADONLY: boolean = false;
  exportFileName: string = "FdActorReportForms_";
  dbops: DBOperation;


  columns: any[] = [

    {
      display: 'TemplateName',
      variable: 'TemplateName',
      filter: 'text'
    },
    {
      display: 'ReportType',
      variable: 'ReportType',
      filter: 'text'
    }
    ,
    {
      display: 'Date',
      variable: 'Date',
      filter: 'date'
    }
    
  ];
  sorting: any = {
    column: 'Date',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];

    this.gridbtns = [
      {
        title: 'XX',
        keys: ["ActorReportCode"],
        action: DBOperation.delete,
        ishide: false
      },


    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {

      case DBOperation.create:
        // alertFunctions.AlertParam('add')
        this.openNewContent();

        break;

      case DBOperation.delete:
        // alertFunctions.AlertParam(gridaction.values[0].value);

        break;
    }
  }

  //
  openNewContent() {
    const modalRef = this.modalService.open(NgbActorFormsModal)
    modalRef.componentInstance.ReportType = "Nurse";
    modalRef.result.then(x => { this.GetFdActorReportsDocController() })

  }

}
